export default class ContactApi {
  static URL = "https://izd7l4de6i27fx3txyn6sni7ey0iacgn.lambda-url.eu-west-2.on.aws/";

  static async sendMessage(fullName = "", email = "", message = "") {
    const res = await fetch(ContactApi.URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fullName,
        email,
        message,
      }),
    });

    return await res.json();
  }
};
